import TRIP_STATUSES from './../config/trip.constant';
import CANCEL_ITEM_STATUSES from './../config/cancel-item-statuses';

export default function TripCancellationService(
    tripAPI
) {
    'ngInject';

    Object.assign(this, {
        cancelTrip,
        hasUserAnsweredOnAllQuestions,
        scrollToTheLastSectionWithError,
    });

    function cancelTrip(tripId, cancellation, cancellationForm) {
        const {bookingComMessage} = cancellationForm;

        const options = cancellation.forms
            .filter(statusIsConfirmed)
            .filter(hasSomeFormData)
            .map(({id, type, data}) => ({
                tripItemId: id,
                tripItemType: type,
                supplierOptions: data,
            }));

        const payload = {
            id: tripId,
            options,
        };

        if (bookingComMessage) {
           payload.CancellationReason = bookingComMessage;
        }

        return tripAPI
            .removeTrip(payload)
            .then(({data}) => ({
                data,
                wereSomeTicketsCollected: wereSomeTicketsCollected(data, cancellation),
            }));
    }

    function wereSomeTicketsCollected(data, cancellation) {
        const succeededItemIds = data.CancelledRails
            .filter(cancellationSucceeded)
            .map(({Item1: id}) => id);

        const idsOfItemsWhereUserChooseToCollectTickets = cancellation.forms
            .filter(typeIsRail)
            .filter(statusIsConfirmed)
            .filter(userChooseToCollectTickets)
            .map(({id}) => id);

        return idsOfItemsWhereUserChooseToCollectTickets.some((id) => succeededItemIds.includes(id));
    }

    function hasUserAnsweredOnAllQuestions(cancellation) {
        return cancellation.forms.every(({isFormValid}) => isFormValid);
    }

    function scrollToTheLastSectionWithError() {
        const scrollTop = getOffsetOfFirstSectionWithError() - getHeaderHeight();
        getBody().animate({scrollTop});

        function getBody() {
            return angular.element('html,body');
        }

        function getHeaderHeight() {
            return angular.element('.app-head').height() + 100;
        }

        function getOffsetOfFirstSectionWithError() {
            const selector = 'input.ng-invalid:last';
            return angular.element(selector).offset().top;
        }
    }

    function typeIsRail({type}) {
        return type === 'Rail';
    }

    function cancellationSucceeded({Item2: status}) {
        return status === CANCEL_ITEM_STATUSES.SUCCESS;
    }

    function userChooseToCollectTickets({data: {areTicketsCollected}}) {
        return areTicketsCollected;
    }

    function statusIsConfirmed({item}) {
        return item.Status === TRIP_STATUSES.TRIP_STATUSES.CONFIRMED;
    }

    function hasSomeFormData({data}) {
        return Object.keys(data).length;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-cancellation/trip-cancellation-service.js